import { useSelector } from "react-redux";
import { useMemo } from "react";

const useAuthUser = () => {
  const authUserRaw = useSelector((state) => state.auth.userDetails);

  const user = useMemo(() => {
    let data = authUserRaw;

    // fallback to localStorage (for hard refresh)
    if (!data) {
      try {
        const stored = localStorage.getItem("authUser");
        const parsed = stored ? JSON.parse(stored) : null;
        data = Array.isArray(parsed) ? parsed[0] : parsed;
      } catch {
        data = null;
      }
    }

    // normalize array → object
    if (Array.isArray(data)) return data[0] || {};

    return data || {};
  }, [authUserRaw]);

  return user;
};

export default useAuthUser;
